import {createAction, props as actionProps} from '@ngrx/store';
import {UserModel} from './user/user.model';

export enum ApiVersion {
  V1 = 'application/json',
  V2 = 'application/dmp.api.v2+json'
}

export const ACTION_TYPES = {
  USER_CLEAR: 'USER_CLEAR',
  USER_CHANGED_UNAUTHORIZED: 'USER_CHANGED_UNAUTHORIZED',

  SEGMENT_LIST_GET: 'SEGMENT_LIST_GET',
  SEGMENT_LIST_GET_FOR_VALIDATION: 'SEGMENT_LIST_GET_FOR_VALIDATION',
  SEGMENT_ERROR: 'SEGMENT_ERROR',

  TARGET_ERROR: 'TARGET_ERROR',
  TARGETS_SHARED_FOR_SEGMENT: 'TARGETS_SHARED_FOR_SEGMENT',

  PARTNER_LIST_GET: 'PARTNER_LIST_GET',
  PARTNER_LIST_GET_ERROR: 'PARTNER_LIST_GET_ERROR',

  FETCHING_DATA: 'FETCHING_DATA',

  SEGMENT_VALIDATION_LIST_GET: 'SEGMENT_VALIDATION_LIST_GET',
  SEGMENT_VALIDATION_ERROR: 'SEGMENT_VALIDATION_ERROR',
  SEGMENT_VALIDATION_SET: 'SEGMENT_VALIDATION_SET',
  SEGMENT_VALIDATION_DELETE: 'SEGMENT_VALIDATION_DELETE',
  SEGMENT_VALIDATION_SELECTED: 'SEGMENT_VALIDATION_SELECTED',
  SEGMENT_VALIDATION_UPDATE: 'SEGMENT_VALIDATION_UPDATE',
  SEGMENT_VALIDATION_INIT_DIALOG: 'SEGMENT_VALIDATION_INIT_DIALOG',

  TARGET_SYSTEM_LIST_GET: 'TARGET_SYSTEM_LIST_GET',
  DISTRIBUTION_ACCOUNT_LIST_SET: 'DISTRIBUTION_ACCOUNT_LIST_SET',
  DISTRIBUTION_ACCOUNT_LIST_UPDATE: 'DISTRIBUTION_ACCOUNT_LIST_UPDATE',
  DISTRIBUTION_ACCOUNT_LIST_GET: 'DISTRIBUTION_ACCOUNT_LIST_GET',
  DISTRIBUTION_ACCOUNT_ERROR: 'DISTRIBUTION_ACCOUNT_ERROR'
};
export const userSet = createAction(
  '[User] User set',
  actionProps<{ user: UserModel }>()
);
export const errorHappened = createAction(
  '[Global] Error occured',
  actionProps<{ error: { message: string } }>()
);
export const successHappened = createAction(
  '[Global] Success of action',
  actionProps<{ message: string }>()
);
